import OTPFormContainer from './OTPForm/OTPFormContainer';
import { useOnlyInIframe } from '../../utils/hooks';

function Login() {
  const shouldRender = useOnlyInIframe();

  return shouldRender ? <OTPFormContainer /> : null;
}

export default Login;
